import React, { useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import "./PlannedMaintenance.css";
import {  getFeatureSwitchByKey, getLocalSessionData } from "../../utils/Authentication/handleUserSession";
import { featureSwitchName, LOCALSESSIONDATAKEYS } from "../../constants/AppConstants";

function PlannedMaintenance(props) {
    const { t } = useTranslation(['translation']);
    const { showMaintenanceBanner = false } = props;
    const [visible, setVisible] = useState(false);
    const ecoproId = getLocalSessionData(LOCALSESSIONDATAKEYS.ECOPROID)
    const isMaintenanceBannersEnabled = getFeatureSwitchByKey(featureSwitchName.MAINTENENCE_BANNERS);
    useEffect(() => {
        showMaintenanceBanner || isMaintenanceBannersEnabled ? setVisible(true) : setVisible(false)
        // eslint-disable-next-line
    }, [ecoproId])

    if (!visible) return null;

    return (
        <div className="pm-banner">
            <div className="pm-icon">
                {/* Warning triangle SVG */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24"
                    height="24"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <path d="M10.29 3.86l-6.6 11.48A1 1 0 004.48 17h15.04a1 1 0 00.86-1.66L13.79 3.86a1 1 0 00-1.73 0z" />
                    <line x1="12" y1="9" x2="12" y2="13" />
                    <line x1="12" y1="17" x2="12.01" y2="17" />
                </svg>
            </div>
            <div className="pm-text">
                 <div className="pm-text header">
               { t("BROTHER_PLUS.MAINTENANCE_BANNERS.HEADER")}
            </div>

            <div className="pm-text">
                { t("BROTHER_PLUS.MAINTENANCE_BANNERS.SUB_HEADER")}
            </div>
            </div>


            <button className="pm-close" onClick={() => setVisible(false)} aria-label="Close">
                {/* X SVG */}
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="20"
                    height="20"
                    fill="none"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                >
                    <line x1="18" y1="6" x2="6" y2="18" />
                    <line x1="6" y1="6" x2="18" y2="18" />
                </svg>
            </button>
        </div>
    );
}

export default PlannedMaintenance;
